import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { GetServicesShowDataTypes } from "../../../../Schema/getServiceSegments.types";

export type GetServiceSegmentsLoadAction = {
  type: string;
  payload: { id: number | string; sub_service_id?: string };
};

export type GetServiceSegmentsData = {
  data: GetServicesShowDataTypes;
};

const GetServiceSegments = new ReduxFetchState<
  GetServiceSegmentsData,
  { id: number | string; sub_service_id?: string },
  any
>("getServiceSegments");

export function* watchGetServiceSegments(action: GetServiceSegmentsLoadAction) {
  try {
    const { id, sub_service_id } = action.payload;
    const lang: "fa" | "en" = yield getCurrentLanguage();

    const data: GetServiceSegmentsData = yield axios({
      url: `/api/v1/ai/service/${id}${sub_service_id ? `?sub_service_id_2=${sub_service_id}` : ""}`,
      method: "GET",
      headers: { lang },
    });

    yield put(GetServiceSegments.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(GetServiceSegments.actions.loadFailure(e.message));
  }
}

export function* getServiceSegmentsSagas() {
  yield takeEvery(GetServiceSegments.actionTypes.load, watchGetServiceSegments);
}

export function useGetServiceSegments() {
  const { loading, data, ...getServiceSegmentsState } = useAppSelector(
    (state) => state.getServiceSegments,
  );
  const dispatch = useAppDispatch();

  const dispatchGetServiceSegments = useCallback(
    (data: { id: number | string; sub_service_id?: string }) => {
      dispatch(GetServiceSegments.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...getServiceSegmentsState,
    dispatchGetServiceSegments,
    getServiceSegmentsLoading: loading,
    getServiceSegmentsData: data,
  };
}

export const {
  actionTypes: getServiceSegmentsActionsTypes,
  actions: getServiceSegmentsActions,
  reducer: getServiceSegmentsReducer,
} = GetServiceSegments;
